// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 欢迎页面样式 */

.welcome-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 2rem;
}

.welcome-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}

.crystal-orbs {
  position: absolute;
  width: 100%;
  height: 100%;
}

.orb {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, 
    rgba(250, 204, 21, 0.3), 
    rgba(249, 115, 22, 0.3), 
    rgba(34, 197, 94, 0.3)
  );
  filter: blur(40px);
  animation: float 6s ease-in-out infinite;
}

.orb-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.orb-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  right: 20%;
  animation-delay: 2s;
}

.orb-3 {
  width: 150px;
  height: 150px;
  bottom: 20%;
  left: 30%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

.welcome-container {
  max-width: 600px;
  width: 100%;
  text-align: center;
  z-index: 1;
}

.welcome-header {
  margin-bottom: 3rem;
}

.welcome-title {
  font-size: 3rem;
  font-weight: 700;
  color: var(--gray-800);
  margin: 1.5rem 0 1rem;
  line-height: 1.2;
}

.brand-name {
  display: block;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 3.5rem;
  margin-top: 0.5rem;
}

.welcome-subtitle {
  font-size: 1.125rem;
  color: var(--gray-600);
  line-height: 1.6;
  max-width: 500px;
  margin: 0 auto;
}

.welcome-card {
  padding: 3rem;
  margin-bottom: 3rem;
  animation-delay: 0.2s;
}

.card-header {
  margin-bottom: 2.5rem;
}

.card-header h2 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.75rem;
}

.card-header h2 i {
  color: var(--mango-500);
}

.card-header p {
  color: var(--gray-600);
  font-size: 1rem;
}

.input-section {
  margin-bottom: 2rem;
}

.input-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 1rem;
  color: var(--gray-500);
  z-index: 2;
}

.input-group .crystal-input {
  padding-left: 3rem;
  font-size: 1rem;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.divider {
  position: relative;
  text-align: center;
  color: var(--gray-500);
  font-weight: 500;
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--gray-300);
  z-index: 1;
}

.divider span {
  background: var(--crystal-bg);
  padding: 0 1rem;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(10px);
}

.card-footer {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--gray-200);
}

.features {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.feature {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--gray-600);
  font-size: 0.875rem;
  font-weight: 500;
}

.feature i {
  color: var(--leaf-500);
}

.welcome-info {
  margin-bottom: 2rem;
  animation-delay: 0.4s;
}

.info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.5rem;
}

.info-card {
  padding: 2rem 1.5rem;
  text-align: center;
  transition: transform var(--duration-normal) ease;
}

.info-card:hover {
  transform: translateY(-5px);
}

.info-icon {
  margin-bottom: 1rem;
}

.info-icon i {
  font-size: 2.5rem;
  color: var(--mango-500);
}

.info-card h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

.info-card p {
  color: var(--gray-600);
  font-size: 0.875rem;
  line-height: 1.5;
}

.welcome-footer {
  color: var(--gray-500);
  font-size: 0.875rem;
  animation-delay: 0.6s;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 3px solid var(--gray-200);
  border-top: 3px solid var(--lemon-500);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-overlay p {
  font-size: 1rem;
  font-weight: 500;
  color: var(--gray-700);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .welcome-page {
    padding: 1rem;
  }
  
  .welcome-title {
    font-size: 2.25rem;
  }
  
  .brand-name {
    font-size: 2.5rem;
  }
  
  .welcome-subtitle {
    font-size: 1rem;
  }
  
  .welcome-card {
    padding: 2rem 1.5rem;
  }
  
  .card-header h2 {
    font-size: 1.25rem;
  }
  
  .info-cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .info-card {
    padding: 1.5rem 1rem;
  }
  
  .features {
    flex-direction: column;
    gap: 1rem;
  }
  
  .orb {
    display: none;
  }
}

@media (max-width: 480px) {
  .welcome-title {
    font-size: 1.875rem;
  }
  
  .brand-name {
    font-size: 2rem;
  }
  
  .welcome-card {
    padding: 1.5rem 1rem;
  }
  
  .action-buttons {
    gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/WelcomePage.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB;;;;GAIC;EACD,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["/* 欢迎页面样式 */\n\n.welcome-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  padding: 2rem;\n}\n\n.welcome-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: -1;\n}\n\n.crystal-orbs {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.orb {\n  position: absolute;\n  border-radius: 50%;\n  background: linear-gradient(135deg, \n    rgba(250, 204, 21, 0.3), \n    rgba(249, 115, 22, 0.3), \n    rgba(34, 197, 94, 0.3)\n  );\n  filter: blur(40px);\n  animation: float 6s ease-in-out infinite;\n}\n\n.orb-1 {\n  width: 300px;\n  height: 300px;\n  top: 10%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.orb-2 {\n  width: 200px;\n  height: 200px;\n  top: 60%;\n  right: 20%;\n  animation-delay: 2s;\n}\n\n.orb-3 {\n  width: 150px;\n  height: 150px;\n  bottom: 20%;\n  left: 30%;\n  animation-delay: 4s;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-20px);\n  }\n}\n\n.welcome-container {\n  max-width: 600px;\n  width: 100%;\n  text-align: center;\n  z-index: 1;\n}\n\n.welcome-header {\n  margin-bottom: 3rem;\n}\n\n.welcome-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: var(--gray-800);\n  margin: 1.5rem 0 1rem;\n  line-height: 1.2;\n}\n\n.brand-name {\n  display: block;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 3.5rem;\n  margin-top: 0.5rem;\n}\n\n.welcome-subtitle {\n  font-size: 1.125rem;\n  color: var(--gray-600);\n  line-height: 1.6;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.welcome-card {\n  padding: 3rem;\n  margin-bottom: 3rem;\n  animation-delay: 0.2s;\n}\n\n.card-header {\n  margin-bottom: 2.5rem;\n}\n\n.card-header h2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 0.75rem;\n}\n\n.card-header h2 i {\n  color: var(--mango-500);\n}\n\n.card-header p {\n  color: var(--gray-600);\n  font-size: 1rem;\n}\n\n.input-section {\n  margin-bottom: 2rem;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 1rem;\n  color: var(--gray-500);\n  z-index: 2;\n}\n\n.input-group .crystal-input {\n  padding-left: 3rem;\n  font-size: 1rem;\n}\n\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.divider {\n  position: relative;\n  text-align: center;\n  color: var(--gray-500);\n  font-weight: 500;\n}\n\n.divider::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: var(--gray-300);\n  z-index: 1;\n}\n\n.divider span {\n  background: var(--crystal-bg);\n  padding: 0 1rem;\n  position: relative;\n  z-index: 2;\n  backdrop-filter: blur(10px);\n}\n\n.card-footer {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid var(--gray-200);\n}\n\n.features {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.feature {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--gray-600);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.feature i {\n  color: var(--leaf-500);\n}\n\n.welcome-info {\n  margin-bottom: 2rem;\n  animation-delay: 0.4s;\n}\n\n.info-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1.5rem;\n}\n\n.info-card {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  transition: transform var(--duration-normal) ease;\n}\n\n.info-card:hover {\n  transform: translateY(-5px);\n}\n\n.info-icon {\n  margin-bottom: 1rem;\n}\n\n.info-icon i {\n  font-size: 2.5rem;\n  color: var(--mango-500);\n}\n\n.info-card h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n.info-card p {\n  color: var(--gray-600);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.welcome-footer {\n  color: var(--gray-500);\n  font-size: 0.875rem;\n  animation-delay: 0.6s;\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.loading-spinner {\n  width: 60px;\n  height: 60px;\n  border: 3px solid var(--gray-200);\n  border-top: 3px solid var(--lemon-500);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-overlay p {\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--gray-700);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .welcome-page {\n    padding: 1rem;\n  }\n  \n  .welcome-title {\n    font-size: 2.25rem;\n  }\n  \n  .brand-name {\n    font-size: 2.5rem;\n  }\n  \n  .welcome-subtitle {\n    font-size: 1rem;\n  }\n  \n  .welcome-card {\n    padding: 2rem 1.5rem;\n  }\n  \n  .card-header h2 {\n    font-size: 1.25rem;\n  }\n  \n  .info-cards {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .info-card {\n    padding: 1.5rem 1rem;\n  }\n  \n  .features {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .orb {\n    display: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .welcome-title {\n    font-size: 1.875rem;\n  }\n  \n  .brand-name {\n    font-size: 2rem;\n  }\n  \n  .welcome-card {\n    padding: 1.5rem 1rem;\n  }\n  \n  .action-buttons {\n    gap: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
